import {
  Autocomplete,
  Button,
  Dialog,
  FormControl,
  InputLabel,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Icons } from '../../../../assets/SvgIcons';
import { ComponentHelper } from '../../../../helper/Infra';
import { ICTask } from '../../../../helper/Interfaces';
import {
  getPlayBookDetail,
  postDealTaskList,
} from '../../../../store/feature/playBookDetailSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import classes from './../TodoCard.module.css';

interface ParentTaskDialogProps {
  open: boolean;
  handleClose: (close: boolean) => void;
  taskId: string;
  updateTaskProperty?: (taskId: string, property: string, value: any) => any;
}

export default function ParentTaskDialog(props: ParentTaskDialogProps) {
  const { dealTaskList } = useAppSelector(getPlayBookDetail);
  const componentHelper = new ComponentHelper();
  const { open, handleClose, taskId } = props;
  const dispatch = useAppDispatch();
  const [selectedTask, setselectedTask] = useState<ICTask | undefined>(
    undefined
  );
  const [allTasks, setallTasks] = useState<ICTask[]>([]);

  useEffect(() => {
    setallTasks(dealTaskList ?? []);
  }, [dealTaskList]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="add-user-dialog"
    >
      <div className="dialog-header">
        <div className="headerTitle">Change Parent</div>
        <button
          className="dialog-close-button"
          onClick={() => handleClose(false)}
        >
          <Icons.Cancel width="22" height="22" color="#000000" />
        </button>
      </div>

      <div className="dialog-content">
        <div className={classes.infoTextDelete}>
          <InputLabel id="demo-simple-select-label">
            Choose a parent task
          </InputLabel>
          <FormControl fullWidth>
            <Autocomplete
              id="clear-on-escape"
              style={{ marginTop: 10, width: 150 }}
              value={selectedTask}
              options={allTasks.filter(
                i =>
                  i.id !== taskId &&
                  i.type !== 'dependency' &&
                  i.type !== 'decision' &&
                  i.id !== allTasks.find(d => d.id === taskId)?.parentId &&
                  i.playbookId ===
                    allTasks.find(d => d.id === taskId)?.playbookId
              )}
              onChange={(event, newValue) => {
                if (newValue) setselectedTask(newValue);
                else setselectedTask(undefined);
              }}
              getOptionLabel={(option: ICTask) =>
                option.itemNumber + ' ' + option.name ?? ''
              }
              clearOnEscape
              renderInput={params => (
                <TextField
                  {...params}
                  label=""
                  className="customOutlinedInput"
                  style={{ width: 550 }}
                />
              )}
            />

            {/*<Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedTask?.id ?? ''}
              label="Age"
              onChange={handleChange}
            >
              {dealTaskList.map(t => {
                return <MenuItem value={t.id}>{t.name}</MenuItem>;
              })}
            </Select>*/}
          </FormControl>
        </div>
        <div style={{ marginTop: 20 }}></div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 20,
          }}
        >
          <div></div>
          <div>
            <Button
              className={classes.CancelButton}
              onClick={() => handleClose(false)}
            >
              Cancel
            </Button>
            <Button
              className={classes.ConfirmButton}
              onClick={async () => {
                if (selectedTask) {
                  const res = await componentHelper.changeParentTaskAndOrder(
                    selectedTask.id!,
                    taskId,
                    null,
                    false
                  );
                  if (res.length && res.length > 0) {
                    const changedTaskCollection = res as ICTask[];
                    const legacyTaskList = JSON.parse(
                      JSON.stringify(dealTaskList)
                    ) as ICTask[];
                    let filteredTaskListList = [...legacyTaskList].filter(
                      i => !changedTaskCollection.map(t => t.id).includes(i.id)
                    );

                    filteredTaskListList = [
                      ...filteredTaskListList,
                      ...changedTaskCollection,
                    ];
                    dispatch(postDealTaskList(filteredTaskListList));
                  }

                  toast('Successfully changed');
                  handleClose(false);
                }
              }}
              style={{ opacity: selectedTask === undefined ? '40%' : '100%' }}
              disabled={selectedTask === undefined}
            >
              Done
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
